import React, { useEffect, useState } from 'react';
// import PropTypes from 'prop-types';
// import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import styles from './style.module.scss';
import { updateLastLogin } from 'api/profile';
import Cookies from 'js-cookie';
import { agreePathActiveMybPage, checkLocation } from '../../utils/utils';
import { ReactComponent as MenuHome } from '../../assets/image-icon/SVG_menu_home.svg';
import { ReactComponent as MenuLike } from '../../assets/image-icon/SVG_menu_like.svg';
import { ReactComponent as MenuMessage } from '../../assets/image-icon/SVG_menu_message.svg';
import { ReactComponent as MenuMyPage } from '../../assets/image-icon/SVG_menu_mypage.svg';
import { ReactComponent as MenuSearchUser } from '../../assets/image-icon/SVG_menu_search_user.svg';

import RenderSvgIcon from 'components/RenderSvgIcon';

const wrapStyleIcon1 = {
  width: 24,
  height: 24,
  fill: 'currentColor',
  alignSelf: 'center',
  transition: 'fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
};

function BottomNav1({ location, history, userProfile, isUnReplied }) {
  const [hiddenNav, setHiddenNav] = useState(false);

  useEffect(() => {
    setHiddenNav(
      Cookies.get('hidden_bottom_nav', {
        path: `${process.env.RAZZLE_PUBLIC_URL}/`,
        domain: window.location.host.replace('admin.', ''),
      }) === 'OK'
    );
  }, []);

  const handleChange = async (event, value) => {
    let url = `${process.env.RAZZLE_PUBLIC_URL}/` + value;
    history.push(url);
    typeof window !== 'undefined' && localStorage.removeItem('redirect_home');
    try {
      await updateLastLogin();
      // queryClient.invalidateQueries('profile');
    } catch (e) {
      console.error(e.response?.data?.message);
    }
  };

  let cssWrap = {
    padding: 0,
    minWidth: 0,
    maxWidth: 'none',
  };
  return (
    <AppBar
      className={[styles.app__bar, hiddenNav ? styles.hidden : '', 'iframe-trigger-preview']}
      position="fixed"
      color="primary"
    >
      <BottomNavigation onChange={handleChange} showLabels>
        <BottomNavigationAction
          style={cssWrap}
          icon={
            <RenderSvgIcon
              name={'SVG_menu_home'}
              style={wrapStyleIcon1}
              className={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/home`], location).classActive}
            />
          }
          value="home"
          label={<span style={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/home`], location)}>ホーム</span>}
        />
        <BottomNavigationAction
          style={cssWrap}
          icon={
            <RenderSvgIcon
              name={'SVG_menu_search_user'}
              style={wrapStyleIcon1}
              className={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/search-user`], location).classActive}
            />
          }
          value="search-user"
          label={<span style={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/search-user`], location)}>検索</span>}
        />
        <BottomNavigationAction
          style={cssWrap}
          icon={
            <RenderSvgIcon
              name={'SVG_menu_message'}
              style={wrapStyleIcon1}
              className={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/chat`], location).classActive}
            />
          }
          value="chat"
          label={
            <div style={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/chat`], location)}>
              メッセージ{isUnReplied && <div className={styles.notifyChatUser}></div>}
            </div>
          }
        />
        <BottomNavigationAction
          style={cssWrap}
          icon={
            <RenderSvgIcon
              name={'SVG_menu_like'}
              style={wrapStyleIcon1}
              className={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/like`], location).classActive}
            />
          }
          value="like"
          label={<span style={checkLocation([`${process.env.RAZZLE_PUBLIC_URL}/like`], location)}>いいね</span>}
        />
        <BottomNavigationAction
          style={cssWrap}
          icon={
            <RenderSvgIcon
              name={'SVG_menu_mypage'}
              style={wrapStyleIcon1}
              className={
                checkLocation(
                  [`${process.env.RAZZLE_PUBLIC_URL}/${userProfile?.gender === 2 ? 'mypagefemale' : 'mypagemale'}`],
                  location
                ).classActive
              }
            />
          }
          value={userProfile?.gender === 2 ? 'mypagefemale' : 'mypagemale'}
          label={<span style={checkLocation(agreePathActiveMybPage(), location)}>マイページ</span>}
        />
      </BottomNavigation>
    </AppBar>
  );
}

export default BottomNav1;
